class MonitorKeyboard {
  static originalHeight=0;
  static type=1;
  constructor() {
    MonitorKeyboard.type = this.isIA();
    MonitorKeyboard.originalHeight = window.innerHeight
  }

  /**
   * 获取设备类型
   * @returns {number} 1android 2ios
   */
  isIA = () => {
    const userAgent = typeof window === 'object' ? window.navigator.userAgent : ''
    if (/android/i.test(userAgent)) {
      return 1
    } else if (/iPhone|iPad|iPod/i.test(userAgent)) {
      return 2
    }
  }

  onResize = () => {
    const resizeHeight = window.innerHeight

    if (MonitorKeyboard.originalHeight - resizeHeight > 50) {
      //android 软键盘弹出
      this.show('Android keyboard show')
    } else {
      //android 软键盘收起
      this.hidden('Android keyboard hidden')
    }
  }

  onFocusin = () => {
    //ios 软键盘弹出
    this.show('iOS keyboard show')
  }

  onFocusout = () => {
    //ios 软键盘收起
    this.hidden('iOS keyboard hidden')
  }

  onStart = () => {
    if (this.type == 1) {
      window.addEventListener('resize', this.onResize)
    } else if (this.type == 2) {
      window.addEventListener('focusin', this.onFocusin)
      window.addEventListener('focusout', this.onFocusout)
    }
  }

  onEnd = () => {
    if (this.type == 1) {
      window.removeEventListener('resize', this.onResize)
    } else if (this.type == 2) {
      window.removeEventListener('focusin', this.onFocusin)
      window.removeEventListener('focusout', this.onFocusout)
    }
  }

  /**
   * 传递一个回调函数 键盘弹出时式触发
   * @param fun
   */
  onShow = (fun) => {
    this.show = fun
  }

  /**
   * 传递一个回调函数 键盘隐藏时触发
   * @param fun
   */
  onHidden = (fun) => {
    this.hidden = fun
  }
}

export default MonitorKeyboard



// WEBPACK FOOTER //
// ./src/utils/keyboard.js